import PropTypes from 'prop-types'
import Header from './Header'
import StickyLocationSelector from './StickyLocationSelector'
import FacilityModalWrapper from '../modals/FacilityModalWrapper'

function Layout({ children }) {
  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      <StickyLocationSelector />
      <main className="container mx-auto px-4 py-6">{children}</main>
      <FacilityModalWrapper />
    </div>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
